const tag = '[MediaColumns] ';

export type ColumnTypes =
  | 'album'
  | 'duration'
  | 'addedDate'
  | 'bpm'
  | 'kbps'
  | 'tags'
  | 'playlists'
  | 'year';

export class ToggleColumn {
  static readonly type = `${tag} toggle column showing`;
  constructor(public column: ColumnTypes) {}
}

export class SetMobileColumns {
  static readonly type = `${tag} set mobile default columns`;
}
